import React, { Component } from 'react';
import clientApi from '../../api/client';

import './CloseIcon.less';
export default class CloseIcon extends Component {
    handleClick = () => {
        const { closeReason, callback } = this.props;
        clientApi.closeH5Page({reason: closeReason});
        callback && callback();
    }
    render(){
        return(
            <div className="close_icon pointer" onClick={this.handleClick}></div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/template/HomeworkNew/CloseIcon.jsx